import {
    CHECK_PAYMENT_STATUS,
    CHECK_PAYMENT_STATUS_ERROR,
    CLEAN_CHECK_PAYMENT_STATUS,
    CLEAN_CHECK_PAYMENT_STATUS_ERROR,
} from "_models/redux/types";

const initialState = {
    loaded: undefined,
    method: undefined,
    payload: undefined,
    status: undefined,
    state: undefined,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case CHECK_PAYMENT_STATUS:
            return {
                ...state,
                loaded: true,
                method: action?.method || null,
                payload: action?.payload || {},
                status: action?.status || null,
                state: "success",
            };

        case CHECK_PAYMENT_STATUS_ERROR:
            return {
                ...state,
                loaded: true,
                method: action?.method || null,
                payload: action?.payload || {},
                status: action?.status || null,
                state: "error",
            };

        case CLEAN_CHECK_PAYMENT_STATUS:
            return {
                ...state,
                loaded: false,
                method: action?.method || null,
                payload: action?.payload || undefined,
                status: undefined,
                state: "success",
            };

        case CLEAN_CHECK_PAYMENT_STATUS_ERROR:
            return {
                ...state,
                loaded: false,
                method: action?.method || null,
                payload: action?.payload || undefined,
                status: undefined,
                state: "error",
            };
        default:
            return state;
    }
}
